export const LOGO = 'FullGlass'

export const MAP =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2260.4023343959993!2d45.814246003598406!3d41.946376579151895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb52c1eb56e6d78!2z0JfQsNCy0L7QtCDQmtC40L3QtNC30LzQsNGA0LDRg9C70Lg!5e0!3m2!1sru!2sge!4v1657041766605!5m2!1sru!2sge'

export const ADDRESS = 'Georgia, Kvareli, st. Chavchavadze, 55'
export const WORKTIME = 'Opening hours: from 9:00 to 18:00, seven days a week'
